import { generatePath } from "react-router-dom";

import { Locale, MentionType, Sentiment, Source } from "@/constants";
import { MentionCard } from "@/types/MentionCard";
import { SearchFilter } from "@/types/SearchFilter";

import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

type AnchorResponse = {
  feed_index: number;
};

type PublicMentionResponse = {
  report_title: string;
  mention_card: MentionCard;
};

export const getAnchor = async (mention_uuid: string) => {
  return fetcher_v2<AnchorResponse>(
    generatePath(URLS.SEARCHES_FIND_FEED_INDEX, {
      mention_uuid: mention_uuid,
    })
  );
};

export const getPublicMention = (public_id: Uuid, locale = "sv") => {
  return fetcher_v2<PublicMentionResponse>(
    generatePath(URLS.PUBLIC_MENTION, { public_id }),
    {
      method: "GET",
      body: {
        locale,
      },
    }
  );
};

type ReportMentionPagination<T> = T & {
  meta: {
    total_mentions: number;
    total_episodes: number;
    page_number: number;
    total_num_pages: number;
    has_previous: boolean;
    has_next: boolean;
    previous_page_number: number;
    next_page_number: number;
  };
};
type MentionModalEpisode = {
  text: string;
  text_without_bolding: string;
  context: MentionType;
  public_url: string;
  timing: number | null;
  similar_mentions_count: number;
  similar_mentions: [];
  sentiment?: Sentiment;
  topics: string[];
  episode_title: string;
  episode_external_url: string;
  artwork_url: string;
  episode_description: string;
  episode_published_date: string;
  channel_title: string;
  channel_type: Source;
  channel_language: Locale;
  channel_estimated_reach: number;
  // channel_type_specific_reach: {};
  external_source: string;
  episode_media_source: string | null;
  url_with_timing: string;
  unique_temp_id: string;
  public_id: string;
  total_length: null;
  youtube_id: string;
  reach: 2403;
  engagement: null;
  pr_value: 1442;
  popularity_score: null;
};

type MentionModalChannel = {
  name: string;
  channel_type: Source;
  mentions_count: number;
  cover: string;
  reach: number;
};

export type PaginatedReportList = ReportMentionPagination<{
  channels?: MentionModalChannel[];
  mentions?: MentionModalEpisode[];
}>;

export const getReportMentions = (
  params: SearchFilter & {
    searches?: string;
    report?: string;
    page?: number;
  }
) =>
  fetcher_v2<PaginatedReportList>(URLS.REPORT_MENTIONS, {
    method: "GET",
    body: params,
  });
